/**
 * 
 * key
 * 
 */


const key = 'ZnJlZWxhbmNlclByb2plY3Rpb25zTGlzdA=='

export default key 